<template>
    <div class="settlementCard">
        <div class="toolRight">
            <el-button type="primary" size="small" @click="toDialog('add')">
                <i class="el-icon-circle-plus-outline"></i>添加
            </el-button>
            <el-button type="primary" size="small" @click="toModifyAccount">修改结算账户信息</el-button>
        </div>
        <div>
            <el-table :data="tableData" border style="width: 100%" :row-style="tableRowStyle">
                <el-table-column prop="shotCardNo" align="center" label="银行账户号码"></el-table-column>
                <el-table-column prop="bankCardTypeCn" align="center" label="银行账户类型"></el-table-column>
                <el-table-column prop="bankName" align="center" label="开户行"></el-table-column>
                <el-table-column prop="defaultSettleCardCn" align="center" label="是否结算卡"></el-table-column>
                <el-table-column prop="createTime" align="center" label="创建时间"></el-table-column>
                <!--<el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    width="230">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" v-if="scope.row.examineStatus!=='EXAMINE'" @click="toDialog('edit',scope.row.uuid)">修改</el-button>
                    </template>
                </el-table-column>-->
            </el-table>
        </div>
        <!-- // 添加 -->
        <AddBank ref="addBankRef"/>
        <!-- // 修改结算账户信息 -->
        <ModifyAccount ref="ModifyAccountRef"/>

    </div>
</template>

<script>
import {listSettledCard} from "../../utils/interface";
import AddBank from "./addBank"  // 添加
import ModifyAccount from "./modifyAccount"  // 修改结算账户信息

export default {
    name: "settlementCard",
    components: {
        AddBank,
        ModifyAccount
    },
    data() {
        return {
            tableData: [],
        };
    },
    mounted() {
        this.searchSettleCard();
    },
    provide(){
        return {
            searchSettleCard: this.searchSettleCard
        }
    },
    methods: {
        toDialog(type) {
            this.$refs.addBankRef.init(type)
        },
        toModifyAccount() {
            this.$refs.ModifyAccountRef.init()
        },
        tableRowStyle({row}){
            if (row.defaultSettleCard) {
                return {background:"#8cefbd"};
            }
        },
        searchSettleCard(){
            listSettledCard().then(resp=>{
                this.tableData = resp;
            });
        }
    },
};
</script>

<style lang="less" scoped>
.toolRight {
    padding-bottom: 20px;

    button {
        height: 30px;
        background: rgba(21, 126, 251, 1);
        border: none;
        border-radius: 15px;
        font-size: 13px;
        color: #fff;

        i {
            padding-right: 5px;
        }

        &:hover {
            background: #61a2f0;
        }
    }
}

.settlementCard {
    padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/balance/settlementCard.vue